angular.module('bmsApp.merrymaids.schedule')
	.controller('MMScheduleRouteJobSelectionModalCtrl', [
		'$scope',
		'$window',
		'$modalInstance',
		'date',
		'routes',
		'unroutedJobParts',
		function ($scope,
				  $window,
				  $modalInstance,
				  date,
				  routes,
				  unroutedJobParts) {



			function generateWorksheets() {
				if (self.selectedJobPartIds.length) {
					var paramString = $.param({
						date: date,
						'job_part_ids': self.selectedJobPartIds
					});
					$window.open('merrymaids/scheduling/worksheets?' + paramString, '_blank');
					$modalInstance.dismiss('cancel');
				}
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			var self = $scope.MMScheduleRouteJobSelectionModalCtrl = {
				routes: routes,
				unroutedJobParts: unroutedJobParts,
				selectedJobPartIds: [],
				methods: {
					generateWorksheets: generateWorksheets,
					cancel: cancel
				}
			};

			angular.forEach(routes, (route) => {
				angular.forEach(route.job_parts, (jobPart) => {
					self.selectedJobPartIds.push(jobPart.id);
				});
			});

			angular.forEach(unroutedJobParts, (jobPart) => {
				self.selectedJobPartIds.push(jobPart.id);
			});

		}
	]);
